<template>
    <div class="white-wrapper">
        <main class="privacy">
            <div class="privacy__wrapper">
                <div class="privacy__big-title">
                    <h1>Çerez Politikası</h1>
                </div>
                <div class="privacy__description">
                    <h1 style="text-align: center;">ÇEREZ POLİTİKASI</h1>
                    <p><br></p>
                    <p><u style="font-size: 10pt;">&nbsp;</u><b style="font-size: 10pt;"><u>Bölümler</u></b></p>
                    <p><br></p>
                    <p><i style="font-size: 10pt;">Çerezler nedir ve bunları nasıl kullanıyoruz? Çerezler ne kadar
                        süreyle işlevsel kalır?</i></p>
                    <p><i style="font-size: 10pt;">Bu sitede hangi tür çerezler kullanılıyor? Üçüncü taraf çerezler
                        nedir?</i></p>
                    <p><i style="font-size: 10pt;">Çerezler nasıl kontrol edilir ve silinir? Çerez kullanımımızdaki
                        değişiklikler İletişim Bilgileri</i></p>
                    <p><i style="font-size: 10pt;">&nbsp;</i></p>
                    <p><br></p>
                    <h1><u>Çerezler nedir ve bunları nasıl kullanıyoruz?</u></h1>
                    <p style="text-align: justify;">Ziyaret
                        ettiğiniz çoğu internet sitesi gibi, internet sitemiz (“site”), örneğin
                        sitemizin diğer kullanıcılarından sizi ayırmak, kullanıcı tercihlerini
                        depolamak ve yönetmek, hedef reklam sunmak, içeriği etkinleştirmek,
                        analitik ve kullanıcı verilerini toplamak için çerez ve diğer benzeri
                        teknolojileri kullanır. Bu, siz sitemizde gezinirken size iyi bir
                        deneyim sunmamıza ve sitemizi geliştirmemize yardımcı olur.</p>
                    <p><br></p>
                    <h1>Çerezler</h1>
                    <p style="text-align: justify;">Çerezler,
                        bir internet sitesini ziyaret ettiğinizde cihazınıza indirilen veya bir
                        internet sayfasında yer alan küçük miktarlarda bilgi içeren metin
                        dosyalarıdır. Çerezler daha sonra her bir ziyarette kaynak internet
                        sitesine ya da o çerezi tanıyan başka bir internet sitesine geri
                        gönderilebilir. Çerezler, bir internet sitesinin bir kullanıcının
                        cihazını tanıdığından ve işlemlerinizi ve tercihlerinizi (giriş
                        ayrıntıları, dil, yazı tipi boyutu ve diğer görüntü tercihleri gibi)
                        belirli bir süre içinde hatırlamasını sağladığından dolayı yararlıdır.</p>
                    <p><br></p>
                    <p style="text-align: justify;">Mümkün
                        oldukça, çerezlerimize ve benzer teknolojilerimize yetkisiz erişimi
                        önlemek için güvenlik önlemleri alınmaktadır. Tek tanıtıcı, yalnızca biz
                        ve/veya yetkili servis sağlayıcılarımızın çerez verilerine
                        erişebilmelerini sağlar.</p>
                    <p><br></p>
                    <p style="text-align: justify;">Bazı
                        çerez türlerinin kullanılabilmesi için sizin rızanız gerekmektedir
                        (aşağıda tanımlandığı şekilde, "kesin gerekli çerezler" hariç olmak
                        üzere). Bir internet sitesine girerken ayarlarınızı değiştirerek, İzin
                        Portalı'na başvurarak ya da tarayıcınızdaki çerez ayarlarını
                        değiştirerek çerezleri istediğiniz zaman reddedebilirsiniz.</p>
                    <p><br></p>
                    <p style="text-align: justify;">Çerezler
                        hakkında, cihazınızda hangi çerezlerin ayarlı olduğu, bunların nasıl
                        yönetileceği ve silineceği de dahil olmak üzere daha fazla bilgiyi <a
                                href="http://www.aboutcookies.org/" target="_blank" style="color: blue;">www.aboutcookies.org</a><span
                                style="color: blue;"> </span>ve <a href="http://www.youronlinechoices.eu/"
                                                                   target="_blank" style="color: blue;">www.youronlinechoices.eu </a>adreslerinde
                        bulabilirsiniz.</p>
                    <p><br></p>
                    <h1>Web İşaretçileri</h1>
                    <p style="text-align: justify;">Web
                        işaretçileri (internet etiketleri, piksel etiketleri ve clear GIF'ler
                        olarak da bilinir), genellikle bir sitede veya e-postada bulunan saydam
                        grafik görüntüleridir. Web işaretçileri, internet sitelerinde
                        ziyaretçilerin eylemlerini ölçmek için çerezlerle birlikte kullanılır.
                        İşaretçinin</p>
                    <p><br></p>
                    <p style="text-align: justify;"><span
                            style="font-size: 11pt; font-family: Arial, sans-serif;"> </span>göründüğü
                        sayfayı indiren bilgisayarın IP adresi, sayfanın URL'si, bulunduğu
                        sayfanın görüntülendiği zaman ve sayfayı görüntülemek için kullanılan
                        tarayıcı türü gibi bilgileri öğrenmek için işaretçiler kullanılabilir.</p>
                    <p style="text-align: justify;">&nbsp;</p>
                    <h1>IP adresleri ve URLler</h1>
                    <p><br></p>
                    <p style="text-align: justify;">IP
                        adresi, belirli elektronik cihazların birbirlerini tanımlamak ve
                        birbirleriyle iletişim kurmak için kullandıkları tek tanıtıcıdır.
                        Sitelerimizi ziyaret ettiğinizde, bir web işaretçisi kullanarak
                        internete bağlanırken kullandığınız cihazın IP adresini görmemiz
                        mümkündür. Bu bilgileri, cihazın genel fiziksel konumunu belirlemek ve
                        site ziyaretçilerinin hangi coğrafi bölgelerden geldiğini anlamak için
                        kullanırız. Ziyaretlerinizi artırmak amacıyla sitemizi sunma şeklimizi
                        değiştirmek için bu bilgileri kullanabiliriz.</p>
                    <p><br></p>
                    <p style="text-align: justify;">URL
                        (Birörnek Kaynak Konumlayıcı), internet üzerindeki her kaynak için bir
                        tek tanıtıcı veya adrestir, yani ziyaret ettiğiniz internet sayfasının
                        adresidir. Hangi sitelerin ve sayfaların ziyaret edildiğini ve sitemizi
                        nasıl kullandığınızı görmek için bu bilgileri kullanırız.</p>
                    <p><br></p>
                    <h1><u>&nbsp;Çerezler ne kadar süreyle işlevsel kalır? </u></h1>
                    <p style="text-align: justify;">Yalnızca
                        tarayıcınızın aktif olduğu süre boyunca (oturum süresi) veya daha uzun
                        bir süre için (daimi) cihazınızda yer eden çerez ve benzer teknolojileri
                        kullanıyoruz. Cihazınız buna izin veriyorsa, bu teknolojileri
                        engellemek, silmek veya devre dışı bırakmakta serbestsiniz.
                        Çerezlerinizi ve çerez tercihlerinizi tarayıcı veya cihaz ayarlarınızdan
                        yönetebilirsiniz.</p>
                    <p><br></p>
                    <h1><u>&nbsp;Bu sitede hangi tür çerezler kullanılıyor?</u></h1>
                    <p>Sitelerimizde farklı çerez türleri kullanıyoruz. Esas olarak aynı şekilde çalışsalar da bazı
                        farklılıklar mevcuttur:</p>
                    <p>&nbsp;</p>
                    <table class="ql-table-blob" style="margin-left: 6pt;" border="1">
                        <tbody>
                        <tr>
                            <td colspan="1" rowspan="1" style="width: 151.0pt;" width="201" valign="top"><p
                                    class="MsoBodyText" style="text-align: center;" align="center"><b><span>Çerez
  türü</span></b><span></span></p></td>
                            <td colspan="1" rowspan="1" style="width: 151.05pt;" width="201" valign="top"><p
                                    class="MsoBodyText" style="text-align: center;" align="center"><b><span>Kısa
  açıklama</span></b><span></span></p></td>
                            <td colspan="1" rowspan="1" style="width: 151.05pt;" width="201" valign="top"><p
                                    class="MsoBodyText" style="text-align: center;" align="center"><b><span>Çerezin
  bilgisayarınızda kalma süresi</span></b><span></span></p></td>
                        </tr>
                        <tr>
                            <td colspan="1" rowspan="1" style="width: 151.0pt;" width="201" valign="top"><p
                                    class="MsoBodyText" style=""><b><span>Kesin gerekli çerezler</span></b><span></span>
                            </p></td>
                            <td colspan="1" rowspan="1" style="width: 151.05pt;" width="201" valign="top"><p
                                    class="TableParagraph" style=""><span style="font-size: 10.0pt;">İnternet sitemizin işleyişi
  için gerekli olan çerezlerdir. Örneğin, internet sitemizin güvenli alanlarına
  giriş yapmanıza, bir alışveriş sepeti kullanmanıza veya e- fatura</span><span> </span><span
                                    style="font-size: 10.0pt;">hizmetlerinden faydalanmanıza</span><span> </span><span
                                    style="font-size: 10.0pt;">olanak sağlayan
  çerezleri<span style=""> </span>içerir.</span></p></td>
                            <td colspan="1" rowspan="1" style="width: 151.05pt;" width="201" valign="top"><p
                                    class="MsoBodyText" style=""><span>Oturum süresince ve Daimi</span></p></td>
                        </tr>
                        <tr>
                            <td colspan="1" rowspan="1" style="width: 151.0pt;" width="201" valign="top"><p
                                    class="MsoBodyText" style=""><b><span>Analitik/performans
  </span><span>çerezleri</span></b><span></span></p></td>
                            <td colspan="1" rowspan="1" style="width: 151.05pt;" width="201" valign="top"><p
                                    class="TableParagraph" style="margin-left: 0cm;"><span style="font-size: 10.0pt;">Ziyaretçilerin sayısını
  bilmemize, saymamıza ve ziyaretçilerin internet sitemizi kullanırken ne
  şekilde hareket ettiklerini görmemize izin verir. Bu, internet sitemizin
  çalışma şeklini geliştirmemize örneğin kullanıcıların aradıklarını kolayca
  bulmasını sağlamamıza yardımcı olur. Bu çerezler üçüncü taraf analitik sağlayıcımız tarafından sağlanabilir, ancak
  yalnızca sitelerimizle ilgili amaçlarla kullanılır.</span></p></td>
                            <td colspan="1" rowspan="1" style="width: 151.05pt;" width="201" valign="top"><p
                                    class="MsoBodyText" style=""><span>Oturum süresince ve Daimi</span></p></td>
                        </tr>
                        <tr>
                            <td colspan="1" rowspan="1" style="width: 151.0pt;" width="201" valign="top"><p
                                    class="MsoBodyText" style=""><b><span>İşlevsellik çerezleri</span></b><span></span>
                            </p></td>
                            <td colspan="1" rowspan="1" style="width: 151.05pt;" width="201" valign="top"><p
                                    class="TableParagraph" style=""><span style="font-size: 10.0pt;">Bu<span
                                    style=""> </span>çerezler,<span style=""> </span>internet<span style=""> </span>sitemize döndüğünüzde sizi ve seçimlerinizi tanımak için
  kullanılır. Bu, içeriğimizi sizin için geliştirmemize ve kişiselleştirmemize
  olanak tanır, sizi isimle selamlar ve tercihlerinizi hatırlar (örneğin, dil
  veya bölge seçiminiz). Ayrıca, çerezler bazı internet sitesi yerleşik
  işlevlerinin düzgün çalışmasını sağlayabilir (örneğin, YouTube video
  gösterimi).</span></p></td>
                            <td colspan="1" rowspan="1" style="width: 151.05pt;" width="201" valign="top"><p
                                    class="MsoBodyText" style=""><span>Oturum süresince ve Daimi</span></p></td>
                        </tr>
                        <tr>
                            <td colspan="1" rowspan="1" style="width: 151.0pt;" width="201" valign="top"><p
                                    class="MsoBodyText" style="">
                                <b><span>Sosyal Medya/Çerezlerin paylaşımı</span></b><span></span></p></td>
                            <td colspan="1" rowspan="1" style="width: 151.05pt;" width="201" valign="top"><p
                                    class="TableParagraph" style=""><span style="font-size: 10.0pt;">İnternet sitemiz, Facebook “Beğen” butonu,
  Twitter “Tweet” butonu, LinkedIn “Paylaş” butonu ve benzeri gibi bazı sosyal
  medya özelliklerini içerebilir. Bu özellikler, IP adresinizi internet
  sitemizde ziyaret ettiğiniz sayfadan alabilir ve özelliğin düzgün çalışmasını
  sağlamak için bir çerez oluşturabilir veya benzer teknolojileri kullanabilir.
  Sosyal medya özellikleri ya bir üçüncü tarafça ya da doğrudan internet
  sitemiz üzerinde barındırılmaktadır. Sosyal ağların kişisel bilgilerinizi <span
                                        style="">nasıl </span>toplayabildiği <span style="">ve </span>kullanabildiği konusunda herhangi bir
  kontrole sahip değiliz ve bunların kullanımı sosyal ağın kendi gizlilik
  politikasına<span style=""> </span>tabidir.</span></p></td>
                            <td colspan="1" rowspan="1" style="width: 151.05pt;" width="201" valign="top"><p
                                    class="MsoBodyText" style=""><span>Oturum süresince ve Daimi</span></p></td>
                        </tr>
                        <tr>
                            <td colspan="1" rowspan="1" style="width: 151.0pt;" width="201" valign="top"><p
                                    class="TableParagraph" style="text-align: justify;"><b><span
                                    style="font-size: 10.0pt;">Hedef belirleme/
  Yeniden hedef belirleme çerezleri</span></b><span style="font-size: 10.0pt;"></span></p></td>
                            <td colspan="1" rowspan="1" style="width: 151.05pt;" width="201" valign="top"><p
                                    class="MsoBodyText" style=""><span>Bu çerezler ziyaretinizi internet sitemize, ziyaret ettiğiniz
  sayfalara ve takip ettiğiniz linklere kaydeder. Bu bilgileri, internet sitelerimizi
  ve onlarla görüntülenen reklamları ilgi alanlarınızla daha alakalı hale
  getirmek için kullanırız. Bu bilgiyi ayrıca bu<span style=""> </span>amaçla üçüncü <span style="">taraflarla </span>paylaşabiliriz.</span>
                            </p></td>
                            <td colspan="1" rowspan="1" style="width: 151.05pt;" width="201" valign="top"><p
                                    class="MsoBodyText" style=""><span>Oturum süresince ve Daimi</span></p></td>
                        </tr>
                        </tbody>
                    </table>
                    <p>&nbsp;</p>
                    <p><span style="font-size: 10pt;">&nbsp;</span></p>
                    <p><span style="font-size: 10pt;">&nbsp;</span></p>
                    <h1>KULLANDIĞIMIZ BİREYSEL ÇEREZLER VE BUNLARI KULLANMA AMAÇLARIMIZA İLİŞKİN DAHA FAZLA BİLGİYİ İZİN
                        PORTALI’NDA BULABİLİRSİNİZ.</h1>
                    <p style="text-align: justify;"><u style="font-size: 10pt;">&nbsp;</u><b
                            style="font-size: 10pt;"><u>Üçüncü taraf çerezler nedir?</u></b></p>
                    <p style="text-align: justify;">Üçüncü
                        tarafların da (örneğin, reklam ağları ve web trafik analiz hizmetleri
                        gibi dış hizmet sağlayıcıları dahil) üzerinde kontrolümüz bulunmayan
                        çerezleri kullanabileceğini lütfen unutmayın. Bu çerezlerin, analitik /
                        performans çerezleri veya hedef belirleme çerezleri olması muhtemeldir.</p>
                    <p><br></p>
                    <h1><u>&nbsp;Çerezler nasıl kontrol edilir ve silinir?</u></h1>
                    <p style="text-align: justify;">İnternet sitemizi ilk kullandığınızda, bir “pop up” çerez bildirimi
                        görürsünüz.</p>
                    <p><br></p>
                    <h1>ÇEREZ
                        BİLDİRİMİNİ KABUL ETTİKTEN SONRA VEYA BU BİLDİRİM EKRANINIZDA
                        BELİRDİKTEN SONRA İNTERNET SİTEMİZİ KULLANARAK BU ÇEREZ POLITIKASININ
                        ŞARTLARINA UYGUN OLARAK CİHAZINIZA ÇEREZ YERLEŞTİRMEMİZİ KABUL ETMİŞ
                        OLURSUNUZ.</h1>
                    <p><br></p>
                    <p style="text-align: justify;">İnternet
                        tarayıcılarının çoğu çerezleri kabul eder, ancak internet tarayıcınızın
                        ayarlarını yeni çerezleri reddetmek, mevcut olanları devre dışı bırakmak
                        veya cihazınıza yeni bir tanesi gönderildiğinde size bildirilmesi için
                        çoğu zaman değiştirebilirsiniz. Yukarıda listelenen çerezlerden herhangi
                        birini kullanmamıza izin vermezseniz, lütfen aşağıdaki talimatları
                        izleyerek bunları devre dışı bırakın. Böylece, bu internet sitesindeki
                        çerezler cihazınıza yerleştirilemez.</p>
                    <p><br></p>
                    <p style="text-align: justify;">Bunu
                        yapmak için tarayıcınız tarafından sağlanan talimatları takip edin
                        (genellikle “Yardım”, “Araçlar” veya “Düzenle” kısmında bulunur).
                        Alternatif olarak, çerezleri nasıl yöneteceğiniz hakkında daha fazla
                        bilgi için <a href="http://www.attacat.co.uk/resources/cookies/how-to-ban" target="_blank"
                                      style="color: blue;">http://www.attacat.co.uk/resources/cookies/how-to-ban </a>adresini
                        ziyaret edebilirsiniz. Ancak, çerezleri reddederseniz veya devre dışı
                        bırakırsanız, internet sitesinin bazı işlevlerinin kaybedilebileceğini
                        lütfen unutmayın.</p>
                    <p><br></p>
                    <p style="text-align: justify;">Ayrıca,
                        bir çerez veya çerez kategorisinin devre dışı bırakılması, çerezleri
                        cihazınızdan silmez; bunu tarayıcınızdan kendiniz yapmanız gerekecektir.</p>
                    <p>&nbsp;</p>
                    <h1><u>&nbsp;Çerez kullanımımızdaki değişiklikler</u></h1>
                    <p style="text-align: justify;">Bu
                        internet sitesi için çerezleri kullanımımızda yapılacak herhangi bir
                        değişiklik burada veya İzin Portalı'nda yayımlanır ve gerekli olması
                        halinde, değişiklikler internet sitelerimizde işaretlenir.</p>
                    <p><br></p>
                    <h1><u>&nbsp;İletişim Bilgileri</u></h1>
                    <p>Bu Politika veya çerez kullanımımız ile ilgili herhangi bir sorunuz olursa lütfen bize <a
                            href="mailto:Turkey.ConsumerRelations@rb.com%20" target="_blank">Turkey.ConsumerRelations@rb.com </a>adresinden
                        ulaşın.</p>
                    <p>Ayrıca bize aşağıdaki adresten ulaşabilirsiniz:</p>
                    <p><br></p>
                    <p>Reckitt Benckiser Ev ve Hijyen Ürünleri A.Ş.</p>
                    <p><b>Merkez Ofis:</b> Orta Mah. Demokrasi Cad. Benckiser Sit. No:92 Tuzla,İstanbul</p>
                    <p><b>Yönetim Ofisi:</b> Dikilitaş Mah. Hakkı Yeten Cad. Selenium Plaza 10 C Fulya, İstanbul</p>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
    import EventBus from "../main";

    export default {
        name: "CookiePolicy",
        mounted() {
            EventBus.$emit('menu-status', false);
            this.$store.commit('navigationStatus', 'subPage');
        }
    }
</script>

<style lang="scss">


    $base-width: 1140px;
    $icon-font: "Font Awesome 5 Free";


    .white-wrapper {

        background-color: white;
        width: 100%;
    }

    .privacy {

        min-height: calc(100vh - 121px);
        color: black;

        &__wrapper {
            width: 666px;
            margin: 0 auto;
        }

        &__big-title h1{
            font-size: 25px;
            font-weight: bold;
            color: black;
            display: flex;
            justify-content: center;
            margin: 30px 0;
        }

        &__description {
            margin-bottom: 50px;
        }
    }


    @media screen and (max-width: 600px) {
        .privacy {

            &__wrapper {
                width: 100%;
            }

            &__description {
                padding: 0 20px;
            }
        }
    }
</style>